import {inject} from '@angular/core';
import {Actions, ofType} from '@ngrx/effects';
import {createFunctionalEffect} from '@shared/utils/effects.helper';
import {catchError, map, of, switchMap} from 'rxjs';

import {SearchActions} from './search.actions';
import {SearchApi} from './search.api';
import {pollUntilSynced} from './search.utils';

export namespace SearchEffects {
  export const searchSubjects$ = createFunctionalEffect(
    (actions$ = inject(Actions), api = inject(SearchApi)) =>
      actions$.pipe(
        ofType(SearchActions.searchSubjects.requested),
        switchMap(({query, pagination}) =>
          api.getSubjects({query, pagination}).pipe(
            switchMap((response) => {
              const payload = response.data;

              if (Array.isArray(payload)) {
                return of(
                  SearchActions.searchSubjects.succeeded({
                    payload,
                    pagination: response.meta.pagination,
                  })
                );
              }

              return pollUntilSynced(api, query, pagination);
            }),
            catchError((e: unknown) =>
              of(SearchActions.searchSubjects.failed({error: e}))
            )
          )
        )
      )
  );

  export const clearSubjects$ = createFunctionalEffect(
    (actions$ = inject(Actions)) =>
      actions$.pipe(
        ofType(SearchActions.searchSubjects.failed),
        map(() => SearchActions.clearSubjects())
      )
  );
}
